module.exports = __webpack_public_path__ + "img/face-smile-wink.ec5d3995.svg";